import { useState } from "react";
import STATE from "../../constanta/state";
import CardStart from "./components/cardStart";
import CardIntro from "./components/cardIntro";
import axios from "axios";
import CONFIG from "../../constanta/config";
import { useEffect } from "react";

import { isMobile } from "react-device-detect";
import Leaderboard from "../leaderboard/leaderboard";

const HomeLBAll = () => {

  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    getConfig();
  }, []);

  const getConfig = () => {
    setLoading(true);
    axios
      .get(CONFIG.URL + "/config?rnd=" + Date.now(), {})
      .then(function (response) {
        if (response.data.status === "SUCCESS") {
          setConfig(response.data.config);
        } else {
        }
        setLoading(false);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
        setLoading(false);
      });
  };

  return (
    <>
      {loading ? (
        <div className="font-bold text-center text-white bg-black w-screen h-screen flex justify-center items-center">
          Loading...
        </div>
      ) : (
        <div
          className="App flex justify-start items-start flex-col min-h-screen "
          style={{
            background: `url('${
              isMobile ? config?.background_mobile : config?.background
            }') no-repeat center center fixed`,
            backgroundSize: "cover",
          }}
        >
          {/* LEADERBOARD */}
          <Leaderboard />
        </div>
      )}
    </>
  );
};

export default HomeLBAll;
